// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 368) return "static/chunks/b8fbd430-442396932b1d2e71.js";
	if (chunkId === 702) return "static/chunks/702-49705a5b56847e49.js";
	if (chunkId === 354) return "static/chunks/354-c752b2d8a652c939.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"112":"layout__minimal","136":"datadog_browser_logs","687":"datadog_browser_rum","818":"layout__client_site_chrome_ui"}[chunkId] || chunkId) + "." + {"103":"2bac5e365e4dd528","112":"18664fdc0ef4e5f5","136":"7d6cdc21eca388bc","508":"2cba15cc35ebc1ff","648":"b9f629f5f1e3c53a","687":"bb1499f732b8457a","818":"ddbf53ce84abbbfc"}[chunkId] + ".js";
};